import * as Parse from 'parse';

const serverUrl = process.env.REACT_APP_PARSE_SERVER_URL;
const jsKey = process.env.REACT_APP_PARSE_SERVER_JSKEY;
const appId = process.env.REACT_APP_PARSE_SERVER_APPID;

export default class {

    public static initialize() {
        Parse!.serverURL = serverUrl!;
        Parse.initialize(appId!, jsKey);
    }
}


// WEBPACK FOOTER //
// ./src/configs/parse.ts